import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_freight_billing_projec_address_selectorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { address_id?: number, account_id?: number, fullTextSearch?: string, project_id?: number }): 
  Promise<{ result: { Id?: number, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string, Contacts?: { Id?: number, AddressId?: number, FirstName?: string, LastName?: string, OwnerEntity?: string, OwnerId?: number, PrimaryEmail?: string, PrimaryTelephone?: string }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { address_id?: number, account_id?: number, fullTextSearch?: string, project_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string, Contacts?: { Id?: number, AddressId?: number, FirstName?: string, LastName?: string, OwnerEntity?: string, OwnerId?: number, PrimaryEmail?: string, PrimaryTelephone?: string }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { address_id?: number, account_id?: number, fullTextSearch?: string, project_id?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string, Contacts?: { Id?: number, AddressId?: number, FirstName?: string, LastName?: string, OwnerEntity?: string, OwnerId?: number, PrimaryEmail?: string, PrimaryTelephone?: string }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      address_id?: number, account_id?: number, fullTextSearch?: string, project_id?: number    }) {
      return false;
    }
}
